import { createSvgIcon } from '@mui/material';

export default createSvgIcon(
  <svg width="73.603" height="73.603" viewBox="0 0 73.603 73.603">
    <g id="log-out" transform="translate(2.75 2.75)">
      <path
        id="Caminho_233"
        data-name="Caminho 233"
        d="M27.2,72.6H12.067A7.567,7.567,0,0,1,4.5,65.036V12.067A7.567,7.567,0,0,1,12.067,4.5H27.2"
        transform="translate(-4.5 -4.5)"
        fill="none"
        stroke="#757e8d"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="5.5"
      />
      <path
        id="Caminho_234"
        data-name="Caminho 234"
        d="M24,48.335,42.918,29.418,24,10.5"
        transform="translate(25.186 4.634)"
        fill="none"
        stroke="#757e8d"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="5.5"
      />
      <path
        id="Caminho_235"
        data-name="Caminho 235"
        d="M58.9,18H13.5"
        transform="translate(9.201 16.052)"
        fill="none"
        stroke="#757e8d"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="5.5"
      />
    </g>
  </svg>,
  'LogOutIcon',
);
